module.exports = __webpack_public_path__ + "static/img/20161019-1.5efdd2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20161019-1.jpg
// module id = r1+y
// module chunks = 0